<script>
  import { line as d3Line } from 'd3-shape';

  /**
   * Multi-year trail for a single municipality. Drawn when the user clicks
   * a dot. We use d3-shape to build the SVG path `d`; Svelte renders the
   * path and markers.
   */
  let { points = [], xScale, yScale } = $props();

  const pathD = $derived.by(() => {
    if (!points || points.length === 0) return '';
    const gen = d3Line()
      .x((d) => xScale(d.participacion_pct))
      .y((d) => yScale(d.margen_pct));
    return gen(points);
  });

  const endpoints = $derived(
    points.length > 1 ? [points[0], points[points.length - 1]] : points
  );
</script>

{#if points.length > 0}
  <g class="trajectory">
    <path class="trajectory-line" d={pathD}></path>
    {#each points as p (p.year)}
      <circle
        class="trajectory-point"
        cx={xScale(p.participacion_pct)}
        cy={yScale(p.margen_pct)}
        r="3"
      ></circle>
    {/each}
    {#each endpoints as p (p.year)}
      <text
        class="trajectory-label"
        x={xScale(p.participacion_pct) + 6}
        y={yScale(p.margen_pct) - 6}
      >{p.year}</text>
    {/each}
  </g>
{/if}
